import React from 'react'

import type { BlueprintComponent } from '@/grove-blueprints/generated-types'

import { useBlueprintBindings } from './blueprint-bindings-context'
import { GROVE_BLUEPRINT_COMPONENT_MAP } from './grove-blueprint-component-map'
import { resolveVisibilityModifier } from './resolve-visibility-modifier'

export function RenderGroveBlueprintNode({
  node,
}: {
  readonly node: BlueprintComponent
}) {
  const { bindingValues } = useBlueprintBindings()

  const visibilityClass = resolveVisibilityModifier(
    'modifiers' in node ? node.modifiers : undefined,
    bindingValues,
  )

  const Component = GROVE_BLUEPRINT_COMPONENT_MAP[node.type]

  if (Component === undefined) {
    if (process.env.SDUI_BLUEPRINT_STRICT_MODE === 'true') {
      throw new Error(
        `Unsupported Blueprint component: ${JSON.stringify(node)}`,
      )
    }

    return null
  }

  if (visibilityClass !== undefined) {
    return (
      <div className={visibilityClass}>
        <Component node={node} />
      </div>
    )
  }

  return <Component node={node} />
}
